import { useEffect, useState } from 'react';
import { useFormContext } from 'src/store/useGameForm.context';
import { uploadFiles as uploadFilesAPI } from 'src/api/files/uploadFiles';
import { ImageField } from './ImageField';

export const GamezomeImageFormControl = ({
  value,
  name,
  lang,
}: {
  value: any;
  name: string;
  lang: string;
}) => {
  const [image, setImage] = useState<{
    file: File | null;
    name: string;
  }>({
    file: null,
    name,
  });

  const form: any = useFormContext();

  const checkUploadFile = async (event: any) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;

      const img = new Image(),
        url = window.URL || window.webkitURL;
      const img_size = {
        width: 0,
        height: 0,
      };
      img.onload = () => {
        img_size.width = img.width;
        img_size.height = img.height;
        setImage({
          file: event.target.files[0],
          name,
        });
      };
      img.src = url.createObjectURL(files[0]);
    }
  };

  useEffect(() => {
    if (!!image.file) {
      const uploadFiles = async () => {
        try {
          const result = await uploadFilesAPI([image.file!], '');
          form.setFieldValue(name, result.urls[0]);
        } catch (error) {
          console.error('Upload error:', error);
        }
      };
      uploadFiles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image]);

  return (
    <ImageField
      value={value}
      onChange={(event) => checkUploadFile(event)}
      label={`Gamezone Image ${lang}`}
      name={name}
      onRemove={() => form.setFieldValue(name, '')}
    />
  );
};
